import React, { useState } from 'react';
import { useMount } from 'ahooks';
import Loading from 'components/loading/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';

import ExcelExport from 'components/export/ExcelExport';
import { getContestazioni } from './contestazioni.function';

const { SearchBar } = Search;

const Contestazioni = () => {
  useMount(getContestazioni);
  const { caricamentoInCorso, contestazioni, clienti } = useSelector((state) => state.bi);
  const [currentCliente, setCurrentCliente] = useState('TUTTI');

  if (caricamentoInCorso) {
    return <Loading />;
  }
  /**
   * Le colonne
   * ["Contratto","Data","CodCliente","RagSociale","Accettato","AnalisiCauseA","AnalisiCauseB","ApertoChiuso","AzioneCorrettiva","Categoria","Correzione","DatadiProduzione","DataReclamo","DataRispostaCliente","DescrizioneAzioneCorrettiva","DescrizioneReclamo","EfficaciaAzioneCorrettiva","LottoCliente","Perchè1","Perchè2","Perchè3","Perchè4","Perchè5","PersonaResponsabile","QtaProdotta","QtaReclamata","SottoCategoria","Stabilimento"]
   */

  return (
    <div>
      <section id="scroll-section">
        <h1>Contestazioni</h1>
      </section>
      <section id="scroll-section">
        <Card>
          <Card.Header className="p-3 py-4">
            <h5 className="m-1">Customer</h5>

            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
            <select onChange={(e) => setCurrentCliente(e.target.value)} value={currentCliente} className="form-select">
              {clienti.map((cliente) => (
                <option key={cliente} value={cliente}>
                  {cliente}
                </option>
              ))}
            </select>
          </Card.Header>
          <div className="d-flex justify-content-between w-92">
            <Card.Title> </Card.Title>
            <ExcelExport idTabella="tabella-contestazioni" />
          </div>
          <Card.Body>
            <ToolkitProvider
              keyField="Id"
              data={contestazioni[currentCliente || 'TUTTI']}
              columns={[
                { dataField: 'Accettato', text: 'Accettato' },
                { dataField: 'AnalisiCauseA', text: 'AnalisiCauseA' },
                { dataField: 'AnalisiCauseB', text: 'AnalisiCauseB' },
                { dataField: 'ApertoChiuso', text: 'ApertoChiuso' },
                { dataField: 'AzioneCorrettiva', text: 'AzioneCorrettiva' },
                { dataField: 'Categoria', text: 'Categoria' },
                { dataField: 'Correzione', text: 'Correzione' },
                { dataField: 'DatadiProduzione', text: 'DatadiProduzione' },
                { dataField: 'DataReclamo', text: 'DataReclamo' },
                { dataField: 'DataRispostaCliente', text: 'DataRispostaCliente' },
                { dataField: 'DescrizioneAzioneCorrettiva', text: 'DescrizioneAzioneCorrettiva' },
                { dataField: 'DescrizioneReclamo', text: 'DescrizioneReclamo' },
                { dataField: 'EfficaciaAzioneCorrettiva', text: 'EfficaciaAzioneCorrettiva' },
                { dataField: 'LottoCliente', text: 'LottoCliente' },
                { dataField: 'Perchè1', text: 'Perchè1' },
                { dataField: 'Perchè2', text: 'Perchè2' },
                { dataField: 'Perchè3', text: 'Perchè3' },
                { dataField: 'Perchè4', text: 'Perchè4' },
                { dataField: 'Perchè5', text: 'Perchè5' },
                { dataField: 'PersonaResponsabile', text: 'PersonaResponsabile' },
                { dataField: 'QtaProdotta', text: 'QtaProdotta' },
                { dataField: 'QtaReclamata', text: 'QtaReclamata' },
                { dataField: 'SottoCategoria', text: 'SottoCategoria' },
                { dataField: 'Stabilimento', text: 'Stabilimento' },
              ]}
              search
            >
              {(props) => (
                <div>
                  <SearchBar {...props.searchProps} />
                  <hr />
                  <BootstrapTable
                    id="tabella-contestazioni"
                    striped
                    bootstrap4
                    condensed
                    wrapperClasses="table-responsive"
                    {...props.baseProps}
                    pagination={paginationFactory({
                      sizePerPage: 10,
                    })}
                  />
                </div>
              )}
            </ToolkitProvider>
          </Card.Body>
        </Card>
      </section>
    </div>
  );
};
export default Contestazioni;
